import { IDENTITY_TOKEN_VALIDATION_API_URL } from './apis';
import { redirectToLogin } from '../utils/login';
export const fetchIdentityUserToken = async (httpClient, errorOnLoginRedirect, errors) => {
  try {
    const {
      data: {
        hasIdentityToken
      }
    } = await httpClient.get(IDENTITY_TOKEN_VALIDATION_API_URL);
    if (!hasIdentityToken) {
      if (errorOnLoginRedirect) {
        throw new Error('User is not logged in', {
          cause: 'no-user-session'
        });
      } else {
        redirectToLogin();
        return {
          hasIdentityToken: false
        };
      }
    }
  } catch (e) {
    if (errorOnLoginRedirect && e.cause === 'no-user-session') {
      throw e;
    }
    errors.push(e);
  }
  return {
    hasIdentityToken: true
  };
};
//# sourceMappingURL=fetch-identity-user-token.js.map